import { usePlazasByClientIdQuery } from '../../services/hooks/usePlazas';

interface PlazasClienteProps {
    clienteId: string;
}

export const PlazasCliente = ({ clienteId }: PlazasClienteProps) => {
    const { 
        data: plazas, 
        isLoading, 
        error 
    } = usePlazasByClientIdQuery(clienteId);

    if (isLoading) return <div>Cargando plazas...</div>;
    if (error) return <div>Error al cargar las plazas</div>;

    return (
        <div className="py-2 px-4 flex flex-col gap-2">
            {plazas?.map((plaza) => (
                <div key={plaza._id} className="p-2 bg-gray-50 rounded">
                    <p className='font-bold text-xs'>{plaza.dia} - {plaza.horaInicio}</p>
                    <p className='font-bold text-xs'>Nivel: {typeof plaza.nivel_id === 'object' ? plaza.nivel_id.nombre : plaza.nivel_id}</p>
                </div>
            ))}
        </div>
    );
};